// extracted by mini-css-extract-plugin
module.exports = {"per-item":"DetailPrice-module__per-item___31JgR","strike":"DetailPrice-module__strike___1Eg_8","savings":"DetailPrice-module__savings___3uaKq"};